import { useContext } from "react";
import AppContext from "../Context/AppContext";
import HeroImage1 from "../img/hero-image-1.jpg";
import HeroImage2 from "../img/hero-image-2.jpg";
import { ReactComponent as TrustpilotRating } from "../img/trustpilot-rating.svg";
import { ButtonDefault } from "./Buttons";

const Hero2 = () => {
  // ADDED [2024-06-05]: Added isNewBuild to conditionally hide "new build" text.
  // Previously: const { referral } = useContext(AppContext);
  // AMENDED [09/07/2026]: Added appointmentType - now sourced from AppContext
  // (set by pathname in App.js) instead of checking pathname directly here.
  // Replaces the /book-appointment-only useLocation check added on 06/07/2026.
  // Previously:
  // const { referral, isNewBuild } = useContext(AppContext);
  //
  // const { pathname } = useLocation();
  // const isBookAppointment =
  //   pathname === "/book-appointment" || pathname === "/book-appointment/";
  const { referral, isNewBuild, appointmentType } = useContext(AppContext);

  return (
    <>
      <section className="block-hero2">
        {/* AMENDED [10/07/2026]: Reduced vertical padding on desktop for
            appointmentType === "protection-review" (lg:py-12, down from
            lg:py-24) so the hero image - which stretches via lg:h-full to
            match this wrapper's height - shrinks proportionally now that
            the subheading/CTA buttons are hidden on this route. Replaces
            the fixed-height image experiment (h-[220px]/lg:h-[400px]),
            which left excess whitespace instead of shrinking the section.
            All other routes keep the original lg:py-24. */}
        {/* Previously:
        <div className="relative bg-white py-0 lg:py-24">
        */}
        <div
          className={`relative bg-white py-0 ${
            appointmentType === "protection-review" ? "lg:py-12" : "lg:py-24"
          }`}
        >
          <div className="img-container relative inset-0 lg:absolute lg:left-[calc(50%+1rem)] lg:block">
            <img
              className="h-[320px] w-full rounded-b-lg object-cover lg:h-full lg:rounded-l-[2rem] lg:rounded-br-none"
              src={referral === "t" ? HeroImage1 : HeroImage2}
              alt=""
            />
          </div>

          <div className="mx-auto px-6 lg:max-w-7xl lg:px-8">
            {/* <!-- <div className="grid gap-8 lg:grid-cols-2"> --> */}
            <div className="mt-8 flex w-full flex-col items-start justify-center lg:mt-0 lg:h-72 lg:w-[calc(50%-1rem)]">
              <h2 className="font-body mb-8 text-left text-4xl font-bold text-gray-900">
                {/* ADDED [2024-06-05]: Conditionally hide "new build" based on isNewBuild. */}
                {/* Previously: Free new build mortgage advice available 7 days a week */}
                {/* AMENDED [11/06/2026]: Capitalise "Mortgage" when "Free" is hidden for referral "ah" */}
                {/* Previously: Free {isNewBuild && "new build "}mortgage advice available 7 days a week */}
                {/* AMENDED [06/07/2026]: Added standalone strapline branch for /book-appointment. PLACEHOLDER - swap in real copy. */}
                {/* AMENDED [09/07/2026]: appointmentType now drives which strapline
                    shows on /book-appointment routes - "protection-review" gets
                    client-approved copy, "general" keeps the placeholder, anything
                    else (null) falls back to the original referral/isNewBuild copy. */}
                {/* Previously:
                {referral !== "ah" && "Free "}
                {isNewBuild && "new build "}
                {referral === "ah" ? "M" : "m"}ortgage advice available 7 days a
                week
                */}
                {/* Intermediate version (06/07/2026), replaced below:
                {isBookAppointment ? (
                  "PLACEHOLDER STRAPLINE - replace with book-appointment copy"
                ) : (
                  <>
                    {referral !== "ah" && "Free "}
                    {isNewBuild && "new build "}
                    {referral === "ah" ? "M" : "m"}ortgage advice available 7
                    days a week
                  </>
                )}
                */}
                {appointmentType === "protection-review" ? (
                  "Protect your home. Protect your lifestyle. Protect your family."
                ) : appointmentType === "general" ? (
                  "PLACEHOLDER STRAPLINE - replace with book-appointment copy"
                ) : (
                  <>
                    {referral !== "ah" && "Free "}
                    {isNewBuild && "new build "}
                    {referral === "ah" ? "M" : "m"}ortgage advice available 7
                    days a week
                  </>
                )}
              </h2>
              {/* AMENDED [10/07/2026]: Subheading paragraph and both CTA buttons
                  (Book an appointment / phone number) are now hidden for
                  appointmentType === "protection-review". All other routes,
                  including "general" and null, keep the original markup. */}
              {/* Previously:
              <p className="mb-8 text-left text-xl font-bold text-gray-900">
                Speak to a specialist mortgage adviser now!
              </p>
              <div className="mb-16 flex flex-col gap-4 sm:flex-row sm:gap-8">
                <ButtonDefault
                  color="red"
                  label="Book an appointment"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="mr-2 h-5 w-5"
                    >
                      <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                      <path
                        fillRule="evenodd"
                        d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  }
                  onClick={() => (window.location.href = "#contact")}
                />
                <ButtonDefault
                  color="plainDark"
                  label="03300 249 115"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="mr-2 h-4 w-4"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  }
                  onClick={() => (window.location.href = "tel:03300249115")}
                />
              </div>
              */}
              {appointmentType !== "protection-review" && (
                <>
                  <p className="mb-8 text-left text-xl font-bold text-gray-900">
                    Speak to a specialist mortgage adviser now!
                  </p>
                  <div className="mb-16 flex flex-col gap-4 sm:flex-row sm:gap-8">
                    <ButtonDefault
                      color="red"
                      label="Book an appointment"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="mr-2 h-5 w-5"
                        >
                          <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                          <path
                            fillRule="evenodd"
                            d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      }
                      onClick={() => (window.location.href = "#contact")}
                    />
                    <ButtonDefault
                      color="plainDark"
                      label="03300 249 115"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="mr-2 h-4 w-4"
                        >
                          <path
                            fillRule="evenodd"
                            d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      }
                      onClick={() => (window.location.href = "tel:03300249115")}
                    />
                  </div>
                </>
              )}
              <a
                href="https://www.trustpilot.com/review/thresholdmortgages.com"
                target="_blank"
                rel="noopener nofollow noreferrer"
                className="mb-0"
              >
                <TrustpilotRating />
              </a>

              {referral === "t" ? (
                <a href="#disclaimer" className="mt-8 text-sm text-gray-900">
                  *Please read the <span className="underline">disclaimer</span>{" "}
                  at the end of the page for more information.
                </a>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero2;
